import { useQuery } from '@tanstack/react-query';

import { fetchApi } from '../strapi';

export interface PlatformBanner {
  id: number;
  title: string;
  subtitle: string;
  button_text: string;
  button_url: string;
  color_theme: 'purple' | 'blue' | 'grey';
  icon_name?: string;
  target_audience:
    | 'ratings_subscribers'
    | 'compass_subscribers'
    | 'all_subscribers'
    | 'public_users'
    | 'all_users';
  is_visible: boolean;
  updatedAt: string;
}

export default function useFetchPlatformBanner(enabled = true) {
  const query = useQuery({
    queryKey: ['platform-banner'],
    queryFn: async () => {
      const response = await fetchApi<PlatformBanner>({
        endpoint: 'platform-banner',
        query: {
          status: process.env.IS_PRODUCTION_APP === 'true' ? 'published' : 'draft',
        },
        wrappedByKey: 'data',
      });
      return response;
    },
    enabled,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  return query;
}
